// Модуль для экспорта графиков в PNG формат
// Использует Chart.js API для получения изображения графика

/**
 * Экспортирует график в PNG файл
 * @param {string} chartId - ID элемента canvas с графиком
 * @param {string} filename - Имя файла для сохранения (без расширения)
 */
export function exportChartToPNG(chartId, filename = 'chart') {
  // Находим canvas элемент с графиком
  const canvas = document.querySelector(`#${chartId} canvas`);

  if (!canvas) {
    console.error(`Canvas с ID ${chartId} не найден`);
    alert('Не удалось найти график для экспорта');
    return;
  }

  try {
    // Получаем изображение из canvas в формате base64
    const imageURL = canvas.toDataURL('image/png');

    // Создаем временную ссылку для скачивания
    const downloadLink = document.createElement('a');
    downloadLink.href = imageURL;
    downloadLink.download = `${filename}.png`;

    // Добавляем ссылку в DOM, кликаем и удаляем
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    console.log(`График ${chartId} успешно экспортирован как ${filename}.png`);
  } catch (error) {
    console.error('Ошибка при экспорте графика:', error);
    alert('Произошла ошибка при экспорте графика');
  }
}

/**
 * Экспортирует график с дополнительными данными (статистика, заголовок)
 * @param {string} chartId - ID элемента canvas с графиком
 * @param {string} filename - Имя файла для сохранения
 * @param {Object} options - Дополнительные опции
 * @param {string} options.title - Заголовок для добавления на изображение
 * @param {Object} options.stats - Статистика для добавления на изображение
 */
export function exportChartWithDetails(chartId, filename, options = {}) {
  const canvas = document.querySelector(`#${chartId} canvas`);

  if (!canvas) {
    console.error(`Canvas с ID ${chartId} не найден`);
    return;
  }

  try {
    // Создаем новый canvas для композиции
    const exportCanvas = document.createElement('canvas');
    const ctx = exportCanvas.getContext('2d');

    // Устанавливаем размеры (больше оригинала для добавления текста)
    const padding = 80;
    exportCanvas.width = canvas.width + (padding * 2);
    exportCanvas.height = canvas.height + (padding * 2);

    // Заливаем белым фоном
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);

    // Добавляем заголовок, если указан
    if (options.title) {
      ctx.fillStyle = '#1f2937'; // text-gray-800
      ctx.font = 'bold 24px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(options.title, exportCanvas.width / 2, 40);
    }

    // Рисуем график
    ctx.drawImage(canvas, padding, padding);

    // Добавляем статистику, если указана
    if (options.stats) {
      ctx.fillStyle = '#6b7280'; // text-gray-500
      ctx.font = '16px sans-serif';
      ctx.textAlign = 'left';

      let yPos = exportCanvas.height - 40;
      Object.entries(options.stats).forEach(([key, value]) => {
        ctx.fillText(`${key}: ${value}`, padding, yPos);
        yPos += 20;
      });
    }

    // Экспортируем композитный canvas
    const imageURL = exportCanvas.toDataURL('image/png');

    const downloadLink = document.createElement('a');
    downloadLink.href = imageURL;
    downloadLink.download = `${filename}.png`;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    console.log(`График ${chartId} с деталями экспортирован как ${filename}.png`);
  } catch (error) {
    console.error('Ошибка при экспорте графика с деталями:', error);
    alert('Произошла ошибка при экспорте графика');
  }
}

/**
 * Инициализирует обработчики для кнопок экспорта
 * Автоматически находит все кнопки с классом 'export-chart-btn' и добавляет обработчики
 */
export function initExportButtons() {
  document.addEventListener('DOMContentLoaded', () => {
    const exportButtons = document.querySelectorAll('.export-chart-btn');

    exportButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const chartId = button.dataset.chartId;
        const filename = button.dataset.filename || 'chart';
        const includeDetails = button.dataset.includeDetails === 'true';

        if (includeDetails) {
          // Собираем статистику из атрибутов данных
          const stats = {};
          Object.keys(button.dataset).forEach(key => {
            if (key.startsWith('stat')) {
              const statName = key.replace('stat', '');
              stats[statName] = button.dataset[key];
            }
          });

          exportChartWithDetails(chartId, filename, {
            title: button.dataset.title,
            stats: Object.keys(stats).length > 0 ? stats : null
          });
        } else {
          exportChartToPNG(chartId, filename);
        }
      });
    });

    console.log(`Инициализировано ${exportButtons.length} кнопок экспорта графиков`);
  });
}

// Автоматическая инициализация при загрузке
initExportButtons();
